<div class="row">
  <div class="col-lg-12 dialog-title" >
    <h1>{{"UpdateSchedule" | translate}}</h1>
    <p class="dialog-title__appointment">{{appointmentSchedule}}</p>
  </div>
</div>


<mat-dialog-content *ngIf="data$ | async as data; else loading" class="schedule-reschedule-dialog" [class.is-saving]="isSaving || false">

  <form [formGroup]="reScheduleForm" (ngSubmit)="onSave()">
      <h2 class="dialog__section-title">
        {{"OwnerData" | translate}}
        <i class="bi bi-pencil-fill edit" (click)="editOwnerAndChangeOwner(3)"></i>
      </h2>

      <mat-button-toggle-group class="dialog__toggle-group" *ngIf="isEditable">
        <mat-button-toggle (click)="editOwnerAndChangeOwner(1)" [ngClass]="EditOwnerStyleButton">
          {{"EditOwner" | translate}}
        </mat-button-toggle>
        <mat-button-toggle (click)="editOwnerAndChangeOwner(2)" [ngClass]="UpdateOwnerStyleButton">
          {{"UpdateOwner" | translate}}
        </mat-button-toggle>
      </mat-button-toggle-group>

      <!-- Show Owner Data -->
      <div class="schedule-reschedule-dialog__grid" *ngIf="!isEditingOwner">
          <p class="dialog__data-field"><span class="bold">{{(companyType === 'Company' ? 'CompanyType' : 'FirstName') | translate}}: </span>{{ nombres?.value }}</p>
          <p *ngIf="showLastName" class="dialog__data-field"><span class="bold">{{"LastName" | translate}}: </span>{{apellidos?.value}}</p>
          <p class="dialog__data-field"><span class="bold">{{"PersonType" | translate}}: </span>{{appointment.personType}}</p>
          <p class="dialog__data-field"><span class="bold">{{"Typededoc" | translate}}: </span>{{documentName}}</p>
          <p class="dialog__data-field"><span class="bold">{{"NumerDocument" | translate}}: </span>{{numeroDeDocumento?.value}}</p>
          <p class="dialog__data-field"><span class="bold">{{"CustomerVehicleRelationship" | translate}}: </span>{{customerVehicleRelationShipName}}</p>
          <p class="dialog__data-field"><span class="bold">{{"Phone" | translate}}: </span>{{celular?.value}}</p>
          <p class="dialog__data-field"><span class="bold">{{"Email" | translate}}: </span>{{email?.value}}</p>
          <p class="dialog__data-field"><span class="bold">{{"Model" | translate}}: </span>{{model?.value}}</p>
          <p class="dialog__data-field"><span class="bold">{{"year" | translate}}: </span>{{year?.value}}</p>
          <p class="dialog__data-field"><span class="bold">{{"Plate" | translate}}: </span>{{placa?.value}}</p>
          <p class="dialog__data-field"><span class="bold">{{"VIN" | translate}}: </span>{{vinNo?.value}}</p>
      </div>
      
      <!-- Edit Owner Data-->
      <div class="owner-form schedule-reschedule-dialog__grid" *ngIf="isEditingOwner" formGroupName="owner">
        
        <mat-form-field class="dialog__form-field">
          <label class="dialog__label">{{(companyType === 'Company' ? 'CompanyType' : 'FirstName') | translate}}</label>
          <input type="text" matInput formControlName="nombres" 
            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
          >
          <mat-error *ngIf="nombres!.hasError('required')">
            {{"NameIs" | translate}} <strong>{{"Required" | translate}}</strong>
          </mat-error>
          <mat-error *ngIf="nombres!.hasError('noSpecialChars')">
            {{"SpecialCharacters" | translate}} <strong>{{"NotAllowed" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="showLastName" class="dialog__form-field">
          <label class="dialog__label">{{"LastName" | translate}}</label>
          <input type="text" matInput formControlName="apellidos"
            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
          >
          <mat-error *ngIf="apellidos!.hasError('required')">
            {{"LastNameIs" | translate}} <strong>{{"Required" | translate}}</strong>
          </mat-error>
          <mat-error *ngIf="apellidos!.hasError('noSpecialChars')">
            {{"SpecialCharacters" | translate}} <strong>{{"NotAllowed" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="dialog__form-field">
          <label class="dialog__label">{{"PersonType" | translate}}</label>
          <mat-select formControlName="tipoDePersona">
            <mat-option *ngFor="let typeOfPerson of data.personTypes"
              [value]="typeOfPerson.typeId">{{typeOfPerson.typeName}}</mat-option>
          </mat-select>
          <mat-error *ngIf="tipoDePersona!.hasError('required')">
            {{"PersontypeIs" | translate}} <strong>{{"Required" | translate}}</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="dialog__form-field">
          <label class="dialog__label">{{"DocumentType" | translate}}</label>
          <mat-select formControlName="tipoDeDocumento">
            <mat-option *ngFor="let typeOfDocument of documentTypesByPersonType" [value]="typeOfDocument.typeId">{{typeOfDocument.typeName}}</mat-option>
          </mat-select>
          <mat-error *ngIf="tipoDeDocumento!.hasError('required')">
            {{"DocumentTypeIs" | translate}} <strong>{{"Required" | translate}}</strong>
          </mat-error>
        </mat-form-field>
        
        <mat-form-field class="dialog__form-field">
          <label class="dialog__label">{{"DocumentNumber" | translate}}</label>
          <input type="text" matInput formControlName="numeroDeDocumento"
             oninput="value = value.replace(/[^0-9 -]/g, '')"
          >
          <mat-error *ngIf="numeroDeDocumento!.hasError('required')">
            {{"DocumentNumberIs" | translate}} <strong>{{"Required" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="dialog__form-field">
          <label class="dialog__label">{{"CustomerVehicleRelationship" | translate}}</label>
          <mat-select formControlName="relacionClienteVehiculo">
            <mat-option *ngFor="let relation of data.vehicleRelationships" [value]="relation.relationshipVehicleId">{{relation.relationshipName | translate}}</mat-option>
          </mat-select>
          <mat-error *ngIf="relacionClienteVehiculo!.hasError('required')">
            {{"RelationshipIs" | translate}} <strong>{{"Required" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="dialog__form-field">
          <label class="dialog__label">{{"Phone" | translate}}</label>
          <input type="text" matInput formControlName="celular"
             oninput="value = value.replace(/[^0-9 ]/g, '')"
          >
          <mat-error *ngIf="celular!.hasError('numbersOnly')">
            {{ 'onlyNumbersAllowed' | translate }}
          </mat-error>
          <mat-error *ngIf="celular!.hasError('required')">
            {{"PhoneIs" | translate}} <strong>{{"Required" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="dialog__form-field">
          <label class="dialog__label">{{"Email" | translate}}</label>
          <input type="email" matInput formControlName="email">
          <mat-error *ngIf="email!.hasError('invalidEmail')">
            {{"EmailNotValid" | translate}}
          </mat-error>
          <mat-error *ngIf="email!.hasError('required')">
            {{"EmailIs" | translate}} <strong>{{"Required" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="dialog__form-field">
          <label class="dialog__label">{{"Model" | translate}}</label>
          <mat-select formControlName="model" [disabled]="EnableVehicleandModel">
            <mat-option *ngFor="let ModelData of modelVehicle" [value]="ModelData" >{{ModelData}}</mat-option>
          </mat-select>
          <mat-error *ngIf="model!.hasError('required')">
            {{"DocumentTypeIs" | translate}} <strong>{{"Required" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="dialog__form-field">
          <label class="dialog__label">{{"year" | translate}}</label>
          <mat-select formControlName="año" [disabled]="EnableVehicleandModel">
            <mat-option *ngFor="let yearData of YearsShow" [value]="yearData">{{yearData}}</mat-option>
          </mat-select>
          <mat-error *ngIf="year!.hasError('required')">
            {{"DocumentTypeIs" | translate}} <strong>{{"Required" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="!placa!.value">
          <mat-label>{{"Plate" | translate}}</mat-label>
          <input type="text" matInput formControlName="placa" maxlength="15" minlength="5"/>
          <mat-error *ngIf="placa!.hasError('required')">
            {{"PlateIs" | translate}} <strong>{{"Required" | translate}}</strong>
          </mat-error>
          <mat-error *ngIf="placa!.hasError('minlength')">
            {{"PlateMustHave" | translate}} <strong>{{"MinimumFiveCharacters" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field >
          <mat-label>{{"Plate" | translate}}</mat-label>
          <input
            type="text"
            matInput
            formControlName="placa"
            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
            maxlength="10"
            minlength="5"
          />
          <mat-error *ngIf="placa!.hasError('required')">
            {{"PlateIs" | translate}}
            <strong>{{"Required" | translate}}</strong>
          </mat-error>
          <mat-error *ngIf="placa!.hasError('minlength')">
            {{"PlateMustHave" | translate}}
            <strong>{{"MinimumFiveCharacters" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        
        <mat-form-field>
          <mat-label>{{"VIN" | translate}}</mat-label>
          <input
            type="text"
            matInput
            formControlName="vin"
            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"

            maxlength="17"
          />
          <mat-error *ngIf="vinNo!.hasError('required')">
            {{"VinIs" | translate}} <strong>{{"Required" | translate}}</strong>
          </mat-error>
          <mat-error *ngIf="vinNo!.hasError('noSpecialChars')">
            {{"OnlyAlphanumericCharacters" | translate}}
          </mat-error>
          <mat-error *ngIf="vinNo!.hasError('minlength')">
            {{"VinMust" | translate}} <strong>{{"MinimumFiveCharacters" | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <!-- <p class="owner__data-field" *ngIf="vinNo!.value!.length > 0">
          <span class="bold">{{"VIN" | translate}}: </span>{{ vinNo?.value }}
        </p> -->

      </div>
      

    <!-- Schedule -->
    <section class="reservation">

      <h2 class="dialog__section-title">
        {{"ReservationData" | translate}}
      </h2>

      <!-- CONTACT CENTER ROLE-->
      <div class="schedule-reschedule-dialog__grid" formGroupName="schedule" *ngIf="currentUserRoleId === 3 || currentUserRoleId === 4">

        <p class="dialog__data-field"><span class="bold">{{"Brand" | translate}}: </span>{{ appointment.brandName }}</p>

        <p class="dialog__data-field"><span class="bold">{{"City" | translate}}: </span>{{ appointment.city }}</p>
        
        <div class="">
          <label class="dialog__label">{{"TypeOfService" | translate}}</label>
          <mat-form-field class="dialog__form-field">
            <mat-select formControlName="tipoDeServicio">
              <mat-option *ngFor="let service of typeOfServices" [value]="service.serviceId">{{service.serviceName | translate}}</mat-option>
            </mat-select>
            <mat-error *ngIf="tipoDeServicio!.hasError('required')">
              {{"TypeOfServiceIs" | translate}} <strong>{{"Required" | translate}}</strong>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="">
          <label class="dialog__label">{{"Workshop" | translate}}</label>
          <mat-form-field class="dialog__form-field" *ngIf="loadingData == false">
            <mat-select formControlName="taller">
              <mat-option *ngFor="let workshop of availableWorkshops" [value]="workshop.workshopId">{{workshop.workshopName}}</mat-option>
            </mat-select>
            <mat-error *ngIf="taller!.hasError('required')">
              {{"WorkShopIs" | translate}} <strong>{{"Required" | translate}}</strong>
            </mat-error>
          </mat-form-field>
        

          <section  *ngIf="loadingData" class="select-loading-data">
            <div  class="pulsing" >
              <mat-spinner [diameter]="50" ></mat-spinner>
            </div>
            <p class="pulsing" >{{ "Loading" | translate }}...</p>
          </section>
        </div>

        <div class="">
          <label class="dialog__label">{{"Advisor" | translate}}</label>
          <mat-form-field class="dialog__form-field">
            <mat-select formControlName="asesor" >
              <!-- <mat-option [value]="">{{"ChooseAdvisor" | translate}}</mat-option> -->
              <mat-option  *ngFor="let advisor of availableAdvisors" [value]="advisor.advisorId">{{ advisor?.advisorFullName }}</mat-option>
            </mat-select>
            <mat-error *ngIf="asesor!.hasError('required')">
              {{"AdvisorIs" | translate}} <strong>{{"Required" | translate}}</strong>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="">
          <label class="dialog__label">{{"Mileage" | translate}}</label>
           <mat-form-field>
            <input type="text" matInput formControlName="kilometraje" maxlength="6"
             oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
             />
            <mat-error *ngIf="kilometraje!.hasError('required')">
              {{"MileageIs" | translate}} <strong>{{"Required" | translate}}</strong>
            </mat-error>
            <mat-error *ngIf="kilometraje!.hasError('noSpecialChars')">
              {{"OnlyAlphanumericCharacters" | translate}}
            </mat-error>
            <mat-error
                *ngIf="kilometraje!.hasError('numbersOnly')"
            >
            {{ 'onlyNumbersAllowed' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="">
          <label class="dialog__label">{{"Date" | translate}}</label>
          <mat-form-field appearance="fill" class="dialog__form-field dialog__form-field-fecha">
            <input matInput [matDatepickerFilter]="myFilter" [matDatepicker]="picker" formControlName="fecha">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="fecha!.hasError('required')">
              {{"DateIs" | translate}} <strong>{{"Required" | translate}}</strong>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="">
          <label class="dialog__label">{{"Time" | translate}}</label>
          <mat-form-field class="dialog__form-field">
            <mat-select formControlName="hora">
              <mat-option *ngFor="let hour of availableAdvisorHours" [value]="hour">{{hour}}</mat-option>
            </mat-select>
            <mat-error *ngIf="hora!.hasError('required')">
              {{"TimeIs" | translate}} <strong>{{"Required" | translate}}</strong>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="schedule-reschedule-dialog__grid-element--wide">
          <p class="dialog__data-field"><span class="bold">{{"Channel" | translate}}: </span>{{selectedChannelName}}</p>
        </div>
        
        <div class="schedule-reschedule-dialog__grid-element--wide">
          <!-- <p class="label">{{"Observations" | translate}}</p>
          <textarea rows="7" class="dialog__textarea" formControlName="observacion"></textarea> -->
          <mat-form-field>
            <mat-label>{{"Observations" | translate}}</mat-label>
            <input
              type="text"
              matInput
              formControlName="observacion"
            oninput="value = value.replace(/[^a-zA-Z0-9 ñáéíóúÁÉÍÓÚ$()#\-_.¿?%]/g, '')"

              maxlength="1000"
              (input)="charCount = reScheduleForm.get('schedule')?.get('observacion')?.value?.length || 0"
            />
            <mat-hint align="start">{{ charCount }}/1000</mat-hint>
          </mat-form-field>
        </div>

      </div>

      <!-- WORKSHOP ROLE-->
      <div class="schedule-reschedule-dialog__grid" formGroupName="schedule" *ngIf="currentUserRoleId === 2 || currentUserRoleId === 6">
        
        <p class="dialog__data-field"><span class="bold">{{"Brand" | translate}}: </span>{{ appointment.brandName }}</p>
        
        <div class="">
          <label class="dialog__label">{{"Advisor" | translate}}</label>
          <mat-form-field class="dialog__form-field">
            <mat-select formControlName="asesor">
              <mat-option *ngFor="let advisor of availableAdvisors" [value]="advisor.advisorId">{{advisor.advisorFullName}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="">
          <label class="dialog__label">{{"TypeOfService" | translate}}</label>
          <mat-form-field class="dialog__form-field" *ngIf="loadingData === false">
            <mat-select formControlName="tipoDeServicio">
              <mat-option *ngFor="let service of typeOfServices" [value]="service.serviceId">{{service.serviceName | translate}}</mat-option>
            </mat-select>
            <mat-error *ngIf="tipoDeServicio!.hasError('required')">
              {{"TypeOfServiceIs" | translate}} <strong>{{"Required" | translate}}</strong>
            </mat-error>
          </mat-form-field>
         
          <section  *ngIf="loadingData" class="select-loading-data">
            <div  class="pulsing" >
              <mat-spinner [diameter]="50" ></mat-spinner>
            </div>
            <p class="pulsing" >{{ "Loading" | translate }}...</p>
          </section>
        </div>
       
        <div class="">
          <label class="dialog__label">{{"Mileage" | translate}}</label>
          <mat-form-field>
            <input type="text" matInput formControlName="kilometraje" maxlength="6"  oninput="value = value.replace(/[^0-9 ]/g, '')"/>
            <mat-error *ngIf="kilometraje!.hasError('required')">
              {{"MileageIs" | translate}} <strong>{{"Required" | translate}}</strong>
            </mat-error>
            <mat-error *ngIf="kilometraje!.hasError('noSpecialChars')">
              {{"OnlyAlphanumericCharacters" | translate}}
            </mat-error>
            <mat-error
                *ngIf="kilometraje!.hasError('numbersOnly')"
            >
              {{ 'onlyNumbersAllowed' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="">
          <label class="dialog__label">{{"Date" | translate}}</label>
          <mat-form-field appearance="fill" class="dialog__form-field dialog__form-field-fecha">
            <input matInput [matDatepickerFilter]="myFilter" [matDatepicker]="picker" formControlName="fecha">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="fecha!.hasError('required')">
              {{"DateIs" | translate}} <strong>{{"Required" | translate}}</strong>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="">
          <label class="dialog__label">{{"Time" | translate}}</label>
          <mat-form-field class="dialog__form-field">
            <mat-select formControlName="hora">
              <mat-option *ngFor="let hour of availableAdvisorHours" [value]="hour">{{hour}}</mat-option>
            </mat-select>
            <mat-error *ngIf="hora!.hasError('required')">
              {{"TimeIs" | translate}} <strong>{{"Required" | translate}}</strong>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="schedule-reschedule-dialog__grid-element--wide">
          <p class="dialog__data-field"><span class="bold">{{"Channel" | translate}}: </span>{{selectedChannelName}}</p>
        </div>
        
        <div class="schedule-reschedule-dialog__grid-element--wide">
          <mat-form-field>
            <mat-label>{{"Observations" | translate}}</mat-label>
            <input
              type="text"
              matInput
              formControlName="observacion"
             oninput="value = value.replace(/[^a-zA-Z0-9 ñáéíóúÁÉÍÓÚ$()#\-_.¿?%]/g, '')"

              maxlength="1000"
              (input)="charCount = reScheduleForm.get('schedule')?.get('observacion')?.value?.length || 0"
            />
            <mat-hint align="start">{{ charCount }}/1000</mat-hint>
          </mat-form-field>
        </div>

      </div>
      
      <!-- ADVISOR ROLE-->
      <div class="schedule-reschedule-dialog__grid" formGroupName="schedule" *ngIf="currentUserRoleId === 1">

        <div class="">
          <mat-form-field>
            <mat-label>{{"TypeOfService" | translate}}</mat-label>
            <mat-select formControlName="tipoDeServicio">
              <mat-option *ngFor="let service of typeOfServices" [value]="service.serviceId">{{service.serviceName | translate}}</mat-option>
            </mat-select>
            <mat-error *ngIf="tipoDeServicio!.hasError('required')">
              {{"TypeOfServiceIs" | translate}} <strong>{{"Required" | translate}}</strong>
            </mat-error>
          </mat-form-field>
        </div>
        
        <div class="">
          <mat-form-field>
            <mat-label>{{"Mileage" | translate}}</mat-label>
            <input type="text" matInput formControlName="kilometraje" maxlength="6" 
             oninput="value = value.replace(/[^0-9 ]/g, '')"
            />
            <mat-error *ngIf="kilometraje!.hasError('required')">
              {{"MileageIs" | translate}} <strong>{{"Required" | translate}}</strong>
            </mat-error>
            <mat-error *ngIf="kilometraje!.hasError('noSpecialChars')">
              {{"OnlyAlphanumericCharacters" | translate}}
            </mat-error>
            <mat-error
                *ngIf="kilometraje!.hasError('numbersOnly')"
            >
              {{ 'onlyNumbersAllowed' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="">
          <mat-form-field appearance="fill">
            <mat-label>{{"Date" | translate}}</mat-label>
            <input matInput [matDatepickerFilter]="myFilter" [matDatepicker]="picker" formControlName="fecha">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="fecha!.hasError('required')">
              {{"DateIs" | translate}} <strong>{{"Required" | translate}}</strong>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="">
          <mat-form-field >
            <mat-label>{{"Time" | translate}}</mat-label>
            <mat-select formControlName="hora">
              <mat-option *ngFor="let hour of availableAdvisorHours" [value]="hour">{{hour}}</mat-option>
            </mat-select>
            <mat-error *ngIf="hora!.hasError('required')">
              {{"TimeIs" | translate}} <strong>{{"Required" | translate}}</strong>
            </mat-error>
          </mat-form-field>
        </div>

        <p class="dialog__data-field"><span class="bold">{{"Channel" | translate}}: </span>{{selectedChannelName}}</p>
        
        
        <div class="schedule-reschedule-dialog__grid-element--wide">
          <mat-form-field>
            <mat-label>{{"Observations" | translate}}</mat-label>
            <input
              type="text"
              matInput
              formControlName="observacion"
            oninput="value = value.replace(/[^a-zA-Z0-9 ñáéíóúÁÉÍÓÚ$()#\-_.¿?%]/g, '')"

              maxlength="1000"
              (input)="charCount = reScheduleForm.get('schedule')?.get('observacion')?.value?.length || 0"
            />
            <mat-hint align="start">{{ charCount }}/1000</mat-hint>
          </mat-form-field>
        </div>

      </div>
      
      <!-- Edit Representative Data-->
      <div class="row" formGroupName="representative">

        <div class="col-lg-6">
          <p>{{"OwnerWillBeOnSite" | translate}}</p>
        </div>

        <div class="col-lg-6">
          <mat-radio-group aria-label="Select an option" formControlName="duenoSePresentara" class="dialog__radio-group">
            <mat-radio-button [value]=true labelPosition="before"  class="dialog__radio-button">{{"Yes" | translate}}</mat-radio-button>
            <mat-radio-button [value]=false  labelPosition="before" class="dialog__radio-button">{{"No" | translate}}</mat-radio-button>
          </mat-radio-group>
        </div>

        <article class="dialog__representative-article" *ngIf="reScheduleForm.controls.representative.get('duenoSePresentara')?.value===false">
            
          <h2 class="dialog__section-title">
            {{"RepresentativeInformation" | translate}}
          </h2>

          <div class="schedule-reschedule-dialog__grid">

          <div class="">
            <label class="dialog__label">{{"FirstName" | translate}}*</label>
            <mat-form-field class="dialog__form-field">
              <input type="text" matInput formControlName="nombresRepresentante" maxlength="40"
            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
              >
              <mat-error *ngIf="nombresRepresentante!.hasError('required')">
                {{"NameIs" | translate}} <strong>{{"Required" | translate}}</strong>
              </mat-error>
              <mat-error *ngIf="nombresRepresentante!.hasError('noSpecialChars')">
                {{"SpecialCharacters" | translate}} <strong>{{"NotAllowed" | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="">
            <label class="dialog__label">{{"LastName" | translate}}*</label>
            <mat-form-field class="dialog__form-field">
              <input type="text" matInput formControlName="apellidosRepresentante" maxlength="40"
            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
              >
              <mat-error *ngIf="apellidosRepresentante!.hasError('required')">
                {{"LastNameIs" | translate}} <strong>{{"Required" | translate}}</strong>
              </mat-error>
              <mat-error *ngIf="apellidosRepresentante!.hasError('noSpecialChars')">
                {{"SpecialCharacters" | translate}} <strong>{{"NotAllowed" | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="">
            <label class="dialog__label">{{"Typededoc" | translate}}</label>
            <mat-form-field class="dialog__form-field">
              <mat-select formControlName="tipoDeDocumentoRepresentante">
                <mat-option *ngFor="let typeOfDocument of representativeDocumentTypes" [value]="typeOfDocument.typeId">{{typeOfDocument.typeName}}</mat-option>
              </mat-select>
              <mat-error *ngIf="tipoDeDocumentoRepresentante!.hasError('required')">
                {{"DocumentTypeIs" | translate}} <strong>{{"Required" | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="">
            <label class="dialog__label">{{"NDocument" | translate}}*</label>
            <mat-form-field class="dialog__form-field">
              <input type="text" matInput formControlName="numeroDeDocumentoRepresentante" maxlength="12"
             oninput="value = value.replace(/[^0-9 ]/g, '')"
              >
              <mat-error *ngIf="numeroDeDocumentoRepresentante!.hasError('required')">
                {{"DocumentNumberIs" | translate}} <strong>{{"Required" | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="">
            <label class="dialog__label">{{"Phone" | translate}}*</label>
            <mat-form-field class="dialog__form-field">
              <input type="text" matInput formControlName="celularRepresentante" maxlength="15"
             oninput="value = value.replace(/[^0-9 ]/g, '')"
              >
              <mat-error *ngIf="celularRepresentante!.hasError('numbersOnly')">
                {{ 'onlyNumbersAllowed' | translate }}
              </mat-error>
              <mat-error *ngIf="celularRepresentante!.hasError('required')">
                {{"PhoneIs" | translate}} <strong>{{"Required" | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="">
            <label class="dialog__label">{{"Email" | translate}}*</label>
            <mat-form-field class="dialog__form-field">
              <input type="email" matInput formControlName="emailRepresentante" maxlength="50">
              <mat-error *ngIf="emailRepresentante!.hasError('email')">
                {{"EmailNotValid" | translate}}
              </mat-error>
              <mat-error *ngIf="emailRepresentante!.hasError('required')">
                {{"EmailIs" | translate}} <strong>{{"Required" | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

        </div>
      
      </article> 
      <!-- End represetntative form section-->

        <!-- End edit representative-->
      </div>

      <!-- End schedule section-->
    </section>

    <!-- Terminos, condiciones y politicas -->
    <section class="termsAndPolitics">
     
      <div class="" formGroupName="termsAndPolitics">

        <div class="col-lg-12 mb-5">
          <div class="row">
            <div class="col-lg-6">
              <p>{{"IAgree" | translate}} <span><a  class="highlight" [href]=termsAndpoliticsLink>{{"TermsAndConditions" | translate}}</a></span></p>
              <mat-error *ngIf="terminos!.hasError('yesSelected') && terminos!.dirty && terminos!.value===false ">
                {{"MustAgreeToTermsAndConditions" | translate}}
              </mat-error>
            </div>

            <div class="col-lg-6" >
              <mat-radio-group aria-label="Select an option" formControlName="terminos" class="dialog__radio-group">
                <mat-radio-button [value]="true" labelPosition="before"  class="dialog__radio-button">{{"Yes" | translate}}</mat-radio-button>
                <mat-radio-button [value]="false"  labelPosition="before" class="dialog__radio-button">{{"No" | translate}}</mat-radio-button>
              </mat-radio-group>
            </div>
         </div>
        </div>

        <div class="col-lg-12">
          <div class="row">

            <div
            class="col-lg-6"
            *ngIf="currentLanguage == 'du-BE' || currentLanguage == 'fr-BE' && countryId !== 2"
          >
            <p>
              <span class="highlight">{{"politicsBelgica1"| translate}}</span>
              {{"politicsBelgica2" | translate}}
            </p>
            <mat-error
              *ngIf="politicas!.hasError('yesSelected') && politicas!.dirty && politicas!.value === false "
            >
              {{"MustAgreeToDataProtectionPolicy" | translate}}
            </mat-error>
          </div>

          <div
            class="col-lg-6"
            *ngIf="currentLanguage !== 'du-BE' && currentLanguage !== 'fr-BE' && countryId !== 2 && countryId !== 1"
          >
            <p>
              {{"DeclareToKnowAndUnderstand"| translate}}
              <span class="highlight"
                >{{"PersonalDataProtectionPolicy" | translate}}</span
              >
              {{"AndAuthorize" | translate}}
            </p>
            <mat-error
              *ngIf="politicas!.hasError('yesSelected') && politicas!.dirty && politicas!.value === false "
            >
              {{"MustAgreeToDataProtectionPolicy" | translate}}
            </mat-error>
          </div>

          <div
              class="col-lg-6"
              *ngIf="countryId === 1"
            >
              <p>
                {{"habeasDataText"| translate}}
                
              </p>
              <mat-error
                *ngIf="politicas!.hasError('yesSelected') && politicas!.dirty && politicas!.value === false "
              >
                {{"MustAgreeToDataProtectionPolicy" | translate}}
              </mat-error>
            </div>
           <!-- Peru -->
           <div
           class="col-lg-6"
           *ngIf=" countryId === 2"
         >
         <p>
          {{"DataProcessing1" | translate}}
           <span>
             <a class="highlight" [href]="termsAndpoliticsLink">{{"DataProcessing2" | translate}}</a></span>{{"DataProcessing3" | translate}}
         </p>
           <mat-error
             *ngIf="politicas!.hasError('yesSelected') && politicas!.dirty && politicas!.value === false "
           >
             {{"MustAgreeToDataProtectionPolicy" | translate}}
           </mat-error>
         </div>
      
            <div class="col-lg-6">
              <mat-radio-group aria-label="Select an option" formControlName="politicas" class="dialog__radio-group">
                <mat-radio-button [value]="true" labelPosition="before"  class="dialog__radio-button">{{"Yes" | translate}}</mat-radio-button>
                <mat-radio-button [value]="false"  labelPosition="before" class="dialog__radio-button">{{"No" | translate}}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
         </div>
  <!-- Peru -->

  <div class="col-lg-12 mb-5" *ngIf="countryId === 2">
    <div class="row">
      <div class="col-lg-6">
        <p>
          {{"DataSendPeru1" | translate}}
          <span>
            <a class="highlight" [href]="termsAndpoliticsLink"> {{"DataSendPeru2" | translate}}</a></span>
        </p>
      </div>

      <div class="col-lg-6" >
        <mat-radio-group aria-label="Select an option" formControlName="DataPeru" class="dialog__radio-group">
          <mat-radio-button [value]="true" labelPosition="before"  class="dialog__radio-button">{{"Yes" | translate}}</mat-radio-button>
          <mat-radio-button [value]="false"  labelPosition="before" class="dialog__radio-button">{{"No" | translate}}</mat-radio-button>
        </mat-radio-group>
      </div>
   </div>
  </div>
 
      </div>
    <!-- End terminos condiciones politicas-->
    </section>

  </form>
  <!-- <pre>{{reScheduleForm.value | json}}</pre> -->

</mat-dialog-content>

<ng-template #loading>
 
  <section  class="dialog-loading-container">
    <div  class="pulsing" >
      <mat-spinner [diameter]="50" ></mat-spinner>
    </div>
    <p class="pulsing" >{{ "Loading" | translate }}...</p>
  </section>
</ng-template>


<section  class="dialog-loading-container" *ngIf="isSaving">
  <div  class="pulsing" >
    <mat-spinner [diameter]="50" ></mat-spinner>
  </div>
  <p class="pulsing" >{{ "Loading" | translate }}...</p>
</section>
<mat-dialog-actions align="center">
  <button mat-dialog-close  class="dialog__button" *ngIf="!isSaving">{{"Cancel" | translate}}</button>
  <button 
  class="dialog__button dialog__button--fill"  
  (click)="onSave()" 
  *ngIf="!isSaving" 
  [disabled]= "validatorsForm()"
  >{{"Accept" | translate}}</button>
</mat-dialog-actions>



